import React from 'react';
import PropTypes from 'prop-types';

import getImageStyle from 'utils/getImageStyle';

import IconPhoto from 'icons/Photo';
import IconVideo from 'icons/Video';

import MediaItemStyled from './MediaItemStyled';

function MediaItem(props) {
  let height;
  let width;
  let scale;
  let size;
  const style = props.cover ? {
    position: 'absolute',
    top: props.size === 'small' ? 0 : '10px',
    left: props.size === 'small' ? 0 : '10px',
  } : undefined;

  switch (props.size) {
    case 'small':
      scale = props.cover ? '0.7' : '1';
      width = '72px';
      height = '56px';
      size = '72x56';
      break;
    case 'square':
      scale = props.cover ? '0.7' : '1';
      width = '80px';
      height = '80px';
      size = '80x80';
      break;
    case 'big':
    default:
      scale = props.cover ? '1' : '2';
      width = '144px';
      height = '88px';
      size = '144x88';
      break;
  }

  return (
    <MediaItemStyled
      cover={props.cover && getImageStyle(props.cover, size)}
      style={{ width: `${width}`, height: `${height}` }}
    >
      {props.mediaType === 'video' && (
        <div style={{ ...style, transform: `scale(${scale})` }}>
          <IconVideo />
        </div>
      )}

      {props.mediaType === 'image' && (
        <div style={{ ...style, transform: `scale(${scale})` }}>
          <IconPhoto />
        </div>
      )}
    </MediaItemStyled>
  );
}

MediaItem.defaultProps = {
  cover: '',
  mediaType: 'image',
  size: 'big',
};

MediaItem.propTypes = {
  cover: PropTypes.string,
  mediaType: PropTypes.oneOf(['image', 'video']),
  size: PropTypes.oneOf(['small', 'big', 'square']),
};

export default MediaItem;
